module.exports = __webpack_public_path__ + "img/icon_pay_tickBig.1775439203884.png";